import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import * as Icons from '@mui/icons-material';
import Typography from '@mui/material/Typography'

// 🔧 Icon rendering helper
function DynamicIcon({ iconName, iconStyle = {} }) {
    const IconComponent = Icons[iconName];
    return IconComponent ? <IconComponent sx={iconStyle} /> : null;
}
function parseSizeProps(size) {
    const defaultSize = { lg: 12, md: 12, sm: 12, xs: 12 };
    const finalSize = size ?? defaultSize;
    return Object.fromEntries(
        Object.entries(finalSize).map(([key, value]) => [
            key,
            Number.isNaN(parseInt(value, 10)) ? defaultSize[key] : parseInt(value, 10)
        ])
    );
}
export default function Save({ widgetStyle = {}, widgetProps = {} }) {
    const { containerStyle, imageStyle, infoStyle, imageContainer, headerStyle, subHeaderStyle, descriptionStyle, buttonStyle } = widgetStyle;
    const { spacing, imageSize, imageUrl, infoSIze, header, subHeader, description, buttonText, href, startIcon, startIconName = 'Favorite', endIcon, endIconName = 'Favorite', iconStyle = {} } = widgetProps;
    return (
        <Grid container spacing={parseSizeProps(spacing)} sx={[containerStyle ?? {}]}>
            <Grid size={parseSizeProps(imageSize)} sx={[imageContainer ?? {}]}>
                <Box height={1} width={1}>
                    <Box width={1} component={'img'} sx={[imageStyle ?? {}]} src={imageUrl ?? 'https://hyper-active.com/assets/images/logo.png'} />
                </Box>
            </Grid>
            <Grid size={parseSizeProps(infoSIze)} sx={[infoStyle ?? {}]}>
                <Typography sx={[headerStyle ?? {}]}>{header}</Typography>
                {subHeader && <Typography sx={[subHeaderStyle ?? {}]}>{subHeader}</Typography>}
                <Typography sx={[descriptionStyle ?? {}]}>{description}</Typography>
                {
                    buttonText &&
                    <Button
                        variant='contained'
                        sx={[buttonStyle ?? {}]}
                        {...(href && !window.location.href.includes('/cms') ? { LinkComponent: Link, to: href } : {})}
                        startIcon={startIcon ? <DynamicIcon iconName={startIconName} iconStyle={iconStyle} /> : undefined}
                        endIcon={endIcon ? <DynamicIcon iconName={endIconName} iconStyle={iconStyle} /> : undefined}
                    >
                        {buttonText}
                    </Button>
                }
            </Grid>
        </Grid>
    )
}